/**
 *  @class
 *  @function FreeShipping
 *  Dual condition: 2+ nail sets (by tag) OR cart >= threshold
 */
if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      var total = parseInt(this.dataset.cartTotal, 10);
      var minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      var nailQty = parseInt(this.dataset.nailQty, 10) || 0;
      var nailGoal = parseInt(this.dataset.nailGoal, 10) || 2;

      var amountPct = Math.min(total / minimum, 1);
      var qtyPct = Math.min(nailQty / nailGoal, 1);
      var met = amountPct >= 1 || qtyPct >= 1;

      var remainingEl = this.querySelector('.free-shipping--text-remaining');
      var fullEl = this.querySelector('.free-shipping--text-full');

      if (met) {
        if (remainingEl) remainingEl.style.display = 'none';
        if (fullEl) fullEl.style.display = 'block';
      } else {
        if (remainingEl) {
          remainingEl.style.display = 'block';
          var span = remainingEl.querySelector('span');
          if (span) {
            var format = window.theme.settings.money_with_currency_format || "${{amount}}";
            span.innerHTML = formatMoney(minimum - total, format);
          }
        }
        if (fullEl) fullEl.style.display = 'none';
      }

      this.style.setProperty('--percentage', Math.max(amountPct, qtyPct));
    }
  }
  customElements.define('free-shipping', FreeShipping);
}